module.exports = __webpack_public_path__ + "static/img/glxt_03.d11d0845.png";